import { SpaceXxs, SpaceXs, SpaceLg } from "@nxt-costco-com/forge-design-tokens";
const availabilityInfoWrapperStyles = {
  display: "flex",
  flexDirection: "column",
  gap: SpaceXxs
};
const priceMayVaryTextStyles = {
  marginLeft: SpaceLg
};
const channelWrapperStyles = {
  cursor: "default",
  display: "flex",
  flexWrap: "nowrap",
  gap: SpaceXs
};
const channelContainerStyles = {
  display: "flex",
  flexDirection: "column"
};
export {
  availabilityInfoWrapperStyles,
  channelContainerStyles,
  channelWrapperStyles,
  priceMayVaryTextStyles
};
